import React from 'react';
import { t } from '../../../locales/i18n';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { Button } from 'semantic-ui-react';
const Container = styled.section``;

export function AuthenticationError() {
  return (
    <Container>
      <header>
        <h1>{t('selectedQueue.authError')}</h1>
        <h4>{t('selectedQueue.authErrorHeader')}</h4>
        <ul>
          <li>{t('selectedQueue.authErrorCheckCredentials')}</li>
        </ul>
      </header>
      <section>
        <div>
          <h5>{t('selectedQueue.goToSettings')}</h5>
          <Link to="/settings">
            <Button label={t('settings')} />
          </Link>
        </div>
        <div>{t('selectedQueue.orDivider')}</div>
        <div>
          <h5>{t('selectedQueue.tryAgain')}</h5>
          <Button onClick={() => window.location.reload()} label={t('tryAgain')} />
        </div>
      </section>
    </Container>
  );
}
